export default {
  code: {
    appStoreDown: 'Apple Store',
    googlePlayDown: 'Google Play',
    androidDown: 'Android SDK',
    huaweiDown: 'Huawei Store',
    stratumMessage: "Click the top right corner to open in the browser.",
    iKnow: "I know",
    update: "Update",
    cancel: "Cancel",
    noData: "no Data",
    installationNotice: "Installation Notice",
    huaweiDownTips: {
      after: "🔐 If installation is blocked, disable Clean Mode:",
      before: "Settings → System and Updates → Pure Mode → Exit"
    },
    xiaomiDownTips: {
      after: "🔐 If installation is blocked, click Single Authorization:",
      before: 'Top right "More" icon → Authorize Single Installation'
    }
  }
};
